import React, { useState, useEffect } from "react";
import Component from "../../Components";
import { useSelector } from "react-redux";
import strings from "../../utils/strings";
import { useNavigate } from "react-router-dom";
const Article = () => {
  const [selectedView, setSelectedView] = useState("artList");
  const [userId, setUserId] = useState("");
  const nav = useNavigate();

  const privilege = useSelector((state) => state.verifyType.privilege);
  useEffect(() => {
    switch (true) {
      case privilege.hasArticleRight:
        nav(strings.navigation.healthArticle);
        break;
      case privilege.hasTNCright:
        nav(strings.navigation.termsCondition);
        break;
      case privilege.hasPatientProfileRight:
        nav(strings.navigation.patientProfile);
        break;
      case privilege.hasNationalIdRight:
        nav(strings.navigation.nationalID);
        break;
      case privilege.hasDepartmentRight:
        nav(strings.navigation.department);
        break;
    }
  }, [privilege]);

  return (
    <div className="article-container">
      {selectedView === "artList" && <Component.ArticleList setSelectedView={setSelectedView} setUserId={setUserId} />}
      {selectedView === "artAdd" && <Component.AddArticle setSelectedView={setSelectedView} />}
      {selectedView === "artEdit" && <Component.EditArticle setSelectedView={setSelectedView} userId={userId} />}
    </div>
  );
};

export default Article;
